import React, { useState, useEffect, useRef } from "react";
import "../../assets/styles/components/Navbars/MobileNav.css";
import {
  CircleUser,
  ChevronRight,
  ChevronLeft,
  Plus,
  Minus,
  Search,
  X,
  User,
  LogOut,
} from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import mobilelogo from "../../assets/images/logo-dark.png";
import { fetchMegamenuData } from "./redux/megaMenuSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import WishlistModal from "../Wishlist/WishlistModal";
import LoginPromptModal from "../LoginModal/LoginPromptModal";
import Mobileansbar from "./MobileNavbar";
import { IoLogoWhatsapp } from "react-icons/io";
// import newsdrwimage from "../../assets/images/navimage.png";
import API from "../../app/api";
import { useCartWishlist } from "../../app/CartWishlistContext";
import { getCategoryUrl, getProductPdpUrl } from "../../utils/url.utils";



const MobileNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { getCartWishlistCount } = useCartWishlist();
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("main");
  const [currentSection, setCurrentSection] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showUserPopup, setShowUserPopup] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);
  const userWrapperRef = useRef(null);
  const { data } = useSelector((state) => state.megamenu);
  const [wdata, setData] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mergedCategories, setmergedCategories] = useState([]);
  const NavsetImage = data[0]?.media;
  const [activeIndex, setActiveIndex] = useState(-1);
  const visibleResults = Array.isArray(searchData)
    ? searchData.slice(0, 8)
    : [];

  const trimmedQuery = query.trim();  

   useEffect(() => {
     const el = document.querySelector(".active-item");
     if (el) {
       el.scrollIntoView({ block: "nearest" });
     }
   }, [activeIndex]);

  useEffect(() => {
  if (showSearch && inputRef.current) {
    setTimeout(() => {
      inputRef.current.focus();
    }, 100);
  }
}, [showSearch]);

  const highlightText = (text, query) => {
  if (!query) return text;
  const regex = new RegExp(`(${query})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <span key={index} className="highlight">
        {part}
      </span>
    ) : (
      part
    )
  );
};


  useEffect(() => {
    const hero_banner_categories = JSON.parse(localStorage.getItem('hero_banner_categories') || '[]');
    setmergedCategories(hero_banner_categories);
  }, [location.pathname]);
  useEffect(() => {
    chatsupport();
    dispatch(fetchMegamenuData());
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [dispatch]);

  useEffect(() => {
    if (isOpen) {
      // Disable page scroll when drawer is open
      document.body.style.overflow = "hidden";
    } else {
      // Enable scroll when drawer is closed
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  //  Check login status dynamically
  useEffect(() => {
    const checkLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };
    checkLogin();
    window.addEventListener("storage", checkLogin);
    return () => window.removeEventListener("storage", checkLogin);
  }, []);

  //  Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userWrapperRef.current && !userWrapperRef.current.contains(event.target)) {
        setShowUserPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const chatsupport = async () => {
    try {
      const res = await API.get("/chat/support");
      if (res.data.status === 200) setData(res.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    setActiveMenu("main");
    setCurrentSection(null);
    setOpenCategory(null);
  };

  const navigateTo = (menu) => setActiveMenu(menu);
  const goBack = () => {
    if (activeMenu === "category") {
      setActiveMenu("shop");
      setCurrentSection(null);
      setOpenCategory(null);
    } else if (activeMenu === "shop") {
      setActiveMenu("main");
    }
  };

  const toggleCategory = (id) => {
    setOpenCategory((prev) => (prev === id ? null : id));
  };

  const handleUserClick = (e) => {
    e.stopPropagation();
    if (!isLoggedIn) navigate("/login");
    else setShowUserPopup((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userName");
    setIsLoggedIn(false);
    setShowUserPopup(false);
    getCartWishlistCount();
    window.dispatchEvent(new Event("storage"));
    navigate("/");
  };

  const handleProfile = () => {
    setShowUserPopup(false);
    navigate("/accounts/profile?tab=your%20orders");
  };

  useEffect(() => {
    if (!query.trim()) {
      setSearchData([]);
      return;
    }
    const timeoutId = setTimeout(() => {
      setLoading(true);
      handleSearch(query);
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [query, dispatch]);

  const handleSearch = async (query) => {
    try {
      const res = await API.get(`search?q=${query}`);
      if (res.data.status === 200) {
        setLoading(false);
        setSearchData(res.data?.data?.products);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {

    document.body.style.overflow = showSearch ? "hidden" : "auto";
  }, [showSearch]);

  const clearSearch = () => {
    setShowSearch(false);
    setQuery("");
    setSearchData([]);
  };

  const getMenuTitle = () => {
    if (activeMenu === "main") return "";
    if (activeMenu === "shop") return "SHOP";
    if (activeMenu === "category") return currentSection?.name || "";
    return "";
  };

  return (
    <>
      <header className="topbar">
        <div className="topbar-left">
          <div className="hamburger" onClick={toggleDrawer}>
            {/* <span></span>
            <span></span>
            <span></span> */}
            <i class="bi bi-list"></i>
          </div>

          <div className="mobile_logo_track" onClick={() => navigate("/")}>
            <img src={mobilelogo} width={130} alt="logo" />
          </div>
        </div>

        <div className="icons">
          <Search
            color="black"
            strokeWidth={1.5}
            onClick={() => setShowSearch(true)}
            className="search-icon"
          />
          <div ref={userWrapperRef} className="user-click-wrapper">
            <CircleUser
              strokeWidth={1.5}
              color="black"
              size={25}
              onClick={handleUserClick}
            />
            {isLoggedIn && showUserPopup && (
              <div
                className="user-popup_AN"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="popup-triangle_mlb"></div>
                <div className="popup-item" onClick={handleProfile}>
                  <User size={20} style={{ marginRight: 8 }} />
                  <span>Profile</span>
                </div>
                <div className="popup-item" onClick={handleLogout}>
                  <LogOut size={18} style={{ marginRight: 8 }} />
                  <span>Logout</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      <Mobileansbar />
      <div className={`drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-header">

          <div>
            <img src={mobilelogo} width={105} alt="logo" />
          </div>

          <div className="track_sector_close">
            <span onClick={toggleDrawer} className="close-btn-mlb">
              ✕
            </span>
          </div>
        </div>

        <div className="trac_back_access">
          {activeMenu !== "main" && (
            <span className="back-btn" onClick={goBack}>
              <ChevronLeft />
            </span>
          )}
          {/*  Add this title */}
          {activeMenu !== "main" && (
            <span className="drawer-title">{getMenuTitle()}</span>
          )}
        </div>

        <div className="menu-container">
          {/* ===== MAIN MENU ===== */}
          <div className={`menu ${activeMenu === "main" ? "active" : ""}`}>
            <ul style={{ marginLeft: "0px" }}>
              <li onClick={() => navigateTo("shop")} className="border-buttom">
                <div className="iteam_main">
                  <div>Shop</div>
                  <div>
                    <ChevronRight />
                  </div>
                </div>
              </li>
              <li className="border-buttom">
                <Link to="/shop/new-arrivals" onClick={toggleDrawer}>
                  NEW ARRIVALS
                </Link>
              </li>
              <li className="border-buttom">
                <Link to="/shop/bestsellers" onClick={toggleDrawer}>
                  BESTSELLERS
                </Link>
              </li>
              <li className="border-buttom">
                <Link to="/shop/offer-spot" onClick={toggleDrawer}>
                  OFFERS SPOT
                </Link>
              </li>
              <li className="border-buttom">
                <Link to="/floor-matcher" onClick={toggleDrawer}>
                  FLOOR MATCHER
                </Link>
              </li>
            </ul>
            {/*  Image after all text content */}
            <div className="drawer-image">
              <img src={NavsetImage} alt="Menu Banner" />
            </div>
          </div>

          {/* ===== SHOP MENU ===== */}
          <div className={`menu ${activeMenu === "shop" ? "active" : ""}`}>
            <ul>
              {data?.map((section) => (
                <li
                  key={section.id}
                  onClick={() => {
                    setCurrentSection(section);
                    navigateTo("category");
                  }}
                >
                  <div className="iteam_main border-buttom">
                    <div>{section.name}</div>
                    <div>
                      <ChevronRight />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* ===== CATEGORY MENU ===== */}
          <div className={`menu ${activeMenu === "category" ? "active" : ""}`}>
            <ul>
              {currentSection?.categories?.map((category) => (
                <li key={category.id}>
                  <div
                    className="iteam_main"
                    onClick={() => toggleCategory(category.id)}
                  >
                    <div>{category.name}</div>
                    <div className="toggle-icon">
                      {openCategory === category.id ? <Minus /> : <Plus />}
                    </div>
                  </div>
                  {openCategory === category.id && (
                    <ul className="submenu">
                      {category.subcategories.map((sub) => (
                        <li key={sub.id} style={{ textTransform: "capitalize" }}>
                          <Link
                            to={getCategoryUrl(sub.category_slug, sub.action_url)}
                            onClick={toggleDrawer}
                          >
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {isOpen && <div className="overlay" onClick={toggleDrawer}></div>}
      {showWishlist && <WishlistModal onClose={() => setShowWishlist(false)} />}
      {showLoginPrompt && (
        <LoginPromptModal onClose={() => setShowLoginPrompt(false)} />
      )}

      {showSearch && (
        <div className="search-fullscreen" onClick={clearSearch}>
          <div
            className="search-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            {/* TOP SEARCH BAR */}

            <div className="search-header">
              <Search size={20} strokeWidth={1.4} />
                  <input
                  ref={inputRef}
                  type="text"
                  className="search-input"
                  placeholder="WHAT ARE YOU LOOKING FOR ?"
                  value={query}
                  autoFocus
                  onClick={(e) => e.stopPropagation()} 
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                    value = value.replace(/^\s+/, "");
                    setQuery(value);
                  }}
                                onKeyDown={(e) => {
                      if (!visibleResults.length) return;
                  
                      //  DOWN
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setActiveIndex((prev) =>
                          prev < visibleResults.length - 1 ? prev + 1 : 0
                        );
                      }
                  
                      //  UP
                      if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setActiveIndex((prev) =>
                          prev > 0 ? prev - 1 : visibleResults.length - 1
                        );
                      }
                  
                      // ENTER
                      if (e.key === "Enter") {
                        e.preventDefault();
                  
                        if (activeIndex >= 0) {
                          const item = visibleResults[activeIndex];
                          clearSearch();
                        } else if (query.trim()) {
                          clearSearch();
                          navigate(`/search?q=${encodeURIComponent(trimmedQuery)}`);
                        }
                      }
                    }}
                />

              <X className="close-search" onClick={clearSearch} />
            </div>

            {/* RESULTS / LOADER */}
            {loading ? (
              <div className="loader-box">
                <div className="spinner-border text-secondary" />
              </div>
            ) : (
              <>
                {Array.isArray(searchData) && searchData.length > 0 && (
                  <div className="search-results-wrapper">

                   {visibleResults.map((item, i) => (
                     <Link
                       key={i}
                       to={getProductPdpUrl(item.action_url, item.sku)}
                       className={`search-result-row ${
                         i === activeIndex ? "active-item" : ""
                       }`}
                       onMouseEnter={() => setActiveIndex(i)} // ✅ hover sync
                       onClick={clearSearch}
                     >
                       <img
                         src={item.media_list?.main?.file}
                         alt={item.name}
                         className="result-thumb"
                       />
                   
                       <div className="result-info">
                         <p>
                           {highlightText(
                             item.name?.split(" ").slice(0, 10).join(" "),
                             query
                           )}
                         </p>
                       </div>
                     </Link>
                   ))}
                  </div>
                )}
                {/* {!loading && query.trim() && searchData.length === 0 && (
                  <div className="no-result-box">
                    <p>No results found</p>
                  </div>
                )} */}
                {!query &&
                  <div className="search-results-wrapper rap-nores">
                    {mergedCategories.slice(0, 8).map((item, i) => (
                      <Link
                        to={getCategoryUrl(item.action_url)}
                        className="search-result-row"
                        key={i}
                        onClick={clearSearch}
                      >
                        <img
                          src={item.media}
                          alt={item.name}
                          className="result-thumb-nores"
                        />
                        <div className="result-info">
                          <p>{item.name}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                }
              </>
            )}
          </div>
        </div>
      )}
      <a
        href={`https://api.whatsapp.com/send?phone=${wdata?.phone}&text=${wdata?.text}`}
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IoLogoWhatsapp className="whatsapp-icon" />
      </a>
    </>
  );
};

export default MobileNav;
